import React, { FC } from 'react';
import { RoomExtraOption } from 'shared-types/Room';
import { Extra } from '../../../../../components/Extras';
import { PerStay } from './PerStay';
import { Options } from './Options';
import { ExtrasCategoryTitle } from './ExtrasCategoryTitle';
import { OvernightPackageRoomExtras } from '@common/features/DynamicPackagesConfigurationWizardNew/types';

type ExtrasProps = {
  extras?: OvernightPackageRoomExtras | null;
  selectedExtras?: { isSelected?: boolean; option: RoomExtraOption }[];
};

export const Extras: FC<ExtrasProps> = ({ extras, selectedExtras = [] }) => (
  <>
    {extras &&
      extras.map((extra, index) => {
        const isSelected = selectedExtras[index] && selectedExtras[index].isSelected;
        const extraOption = selectedExtras[index] && selectedExtras[index].option;
        return (
          <>
            <ExtrasCategoryTitle extras={extras} index={index} />
            <Extra
              featured
              showPrice
              controls={(() => {
                switch (extra.type) {
                  case 'per_stay': {
                    return <PerStay {...extra} index={index} />;
                  }
                  default: {
                    return (
                      <Options
                        {...extra}
                        selectedOption={extraOption}
                        index={index}
                        isSelected={isSelected}
                      />
                    );
                  }
                }
              })()}
              isSelected={isSelected}
              {...(extra as any)}
            />
          </>
        );
      })}
  </>
);
